import styled from 'styled-components';
import { palette, theme } from 'styled-tools';

import { fontFamily, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import downArrow from 'icons/down-arrow.svg';
import rightArrow from 'icons/right-arrow.svg';

export const Wrapper = styled.div`
	margin-bottom: 24px;

	${minWidth('tablet')} {
		display: flex;
	}
`;

export const SelectWrapper = styled.div`
	position: relative;
	z-index: 0;
`;

export const DownArrow = styled(downArrow)`
	position: absolute;
	right: 24px;
	top: 50%;
	transform: translateY(-50%);
	z-index: 1;
`;

export const Select = styled.select`
	appearance: none;
	background: transparent;
	border: 1px solid #dbdbdb;
	border-radius: 6px;
	color: ${palette('gray6')};
	${fontFamily};
	font-size: 15px;
	${fontWeight(FontWeights.Medium)};
	height: 48px;
	margin-bottom: 12px;
	padding: 0 20px;
	text-transform: uppercase;
	width: 100%;

	${minWidth('tablet')} {
		margin-bottom: 0;
		width: 200px;
	}
`;

export const Arrow = styled(rightArrow)`
	transition: ${theme('animation.transition')};
	width: 12px;

	& path {
		fill: ${palette('gray6')};
	}
`;

export const ButtonWrapper = styled.div`
	display: flex;
	flex: 1;
	justify-content: space-between;

	${minWidth('tablet')} {
		padding-left: 48px;
	}
`;

export const NavButton = styled.button`
	align-items: center;
	background: transparent;
	border: none;
	color: ${palette('gray6')};
	cursor: pointer;
	display: flex;
	${fontFamily};
	font-size: 15px;
	${fontWeight(FontWeights.Medium)};
	outline: none;
	text-transform: uppercase;
`;

export const NextArrow = styled(Arrow)`
	margin-left: 8px;
`;

export const PrevArrow = styled(Arrow)`
	margin-right: 8px;
	transform: scale(-1);
`;

export const PrevButton = styled(NavButton)`
	margin-right: auto;

	${minWidth('desktop')} {
		&:hover {
			${PrevArrow} {
				transform: scale(-1) translateX(4px);
			}
		}
	}
`;

export const NextButton = styled(NavButton)`
	margin-left: auto;

	${minWidth('desktop')} {
		&:hover {
			${NextArrow} {
				transform: translateX(4px);
			}
		}
	}
`;
